export default "__VITE_ASSET__DjIsTyfY__"